import { render, staticRenderFns } from "./ProformaDetailPage.vue?vue&type=template&id=7f37aa07&scoped=true&"
import script from "./ProformaDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProformaDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37aa07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f37aa07')) {
      api.createRecord('7f37aa07', component.options)
    } else {
      api.reload('7f37aa07', component.options)
    }
    module.hot.accept("./ProformaDetailPage.vue?vue&type=template&id=7f37aa07&scoped=true&", function () {
      api.rerender('7f37aa07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/ProformaDetailPage.vue"
export default component.exports